<template>
  <b-row>
    <b-col>
      <b-form-group
        label="Hızlı Arama"
        label-for="keywords"
      >
        <b-input-group>
          <b-form-input
            id="keywords"
            v-model="filterParams.keywords"
            placeholder="Ürün Adı, Ürün Kodu..."
            @keydown.enter="getDataList"
          />
          <b-input-group-append v-if="!filterParams.detailSearch">
            <b-button
              @click="getDataList"
            >
              <FeatherIcon icon="SearchIcon" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-row
        v-if="filterParams.detailSearch"
      >
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Marka"
            label-for="brand"
          >
            <b-form-input
              id="brand"
              v-model="filterParams.brand"
              placeholder="Marka"
              @keydown.enter="getDataList"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Model"
            label-for="model"
          >
            <b-form-input
              id="model"
              v-model="filterParams.model"
              placeholder="Model"
              @keydown.enter="getDataList"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Ürün Kategorisi"
            label-for="id_product_categories"
          >
            <v-select
              id="id_product_categories"
              v-model="filterParams.id_product_categories"
              :options="categories"
              :reduce="item => item.id"
              label="title"
              placeholder="Ürün Kategorisi"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Menşei"
            label-for="id_origins"
          >
            <v-select
              id="id_origins"
              v-model="filterParams.id_origins"
              :options="origins"
              label="title"
              :reduce="item => item.id"
              placeholder="Menşei"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="d-flex justify-content-center"
        >
          <b-button
            variant="warning"
            @click="getDataList"
          >
            <FeatherIcon icon="FilterIcon" />
            Filtrele
          </b-button>
        </b-col>
      </b-row>
    </b-col>
    <b-col
      cols="12"
      md="auto"
      style="padding-top: 28px"
    >
      <b-form-checkbox
        v-model="filterParams.detailSearch"
        switch
      >
        Detaylı Arama
      </b-form-checkbox>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'FilterCard',
  components: {
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    vSelect,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
  },
  props: {
    getDataList: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      detail: true,
    }
  },
  computed: {
    categories() {
      return this.$store.getters['productCategories/dataList']
    },
    origins() {
      return this.$store.getters['origins/dataList']
    },
    filterParams() {
      return this.$store.getters['products/filterParams']
    },
  },
  created() {
    this.getCategories()
    this.getOrigins()
  },
  methods: {
    getOrigins() {
      this.$store.dispatch('origins/getDataList')
    },
    getCategories() {
      this.$store.dispatch('productCategories/getDataList', {
        select: [
          'product_categories.id AS id',
          'product_categories.title AS title',
        ],
        where: {
          'product_categories.status': 1,
        },
      })
    },
  },
}
</script>
